module.exports = __webpack_public_path__ + "static/media/text_label.32271591.PNG";